import React from 'react';

const Location = (props) => {
    const makePathContent = () => {
        const arrPath = props.path;
        return (
            <div className='path-wrap'>
                {props.isMenuCollapse &&
                    <button className='btn-sidemenu' onClick={e => props.setIsMenuCollapse(prev => !prev)}>
                        <i className='icoKdc24 expand-24'></i>
                    </button>
                }
                <div className="path">
                    {arrPath.map((item, index, arr) => (
                        <React.Fragment key={index}>
                            <span className="path-doc">{item}</span>
                            {index < arr.length - 1 && <i className="icoKdc12 next"></i>}
                        </React.Fragment>
                    ))}
                </div>
            </div>
        );
    };
    const versionContent = () => {
        if (!props.documents || props.documents.length === 0) {
            return;
        }
        if (!props.documents[0].product) {
            return (
                <div className='doc-nav-right'>
                    <p className='newest'>이 문서의 최신 버전입니다.</p>
                    {props.categoryList.length > 0 && 
                        <p className='newest'>
                            {props.categoryList.map((cate, index) => {
                                if (!["ace", "genuine"].includes(cate.type)) return "";
                                const type = "K-System " + 
                                    cate.type.charAt(0).toUpperCase() + cate.type.slice(1);
                                return index === 0 ? type : ' / ' + type
                            })}
                        </p>
                    }
                </div>
            );
        }
        const productList = [...new Set(props.documents.map(doc => doc.product))];

        const handleProductChange = (e) => {
            const product = e.target.value;
            props.setSelectedProduct(product);
            props.setSelectedVersion("");
        };

        const groupedProducts = props.documents.reduce((acc, item) => {
            if (!acc[item.product]) acc[item.product] = [];
            acc[item.product].push(item);
            return acc;
        }, {});

        const filteredVersions =
            (props.selectedProduct && props.categoryList
                .find((cat) => cat.type === props.selectedProduct)
                ?.sub?.filter((subVersion) =>
                    groupedProducts[props.selectedProduct]?.some(
                        (doc) => doc.version === subVersion
                    )
                )) || [];

        return (
            <div className="doc-nav-right">
                {(!props.maxVersion || !props.selectedVersion || props.maxVersion === props.selectedVersion) &&
                    <p className='newest'>이 문서의 최신 버전입니다.</p>
                }
                <SelectBox
                    label="제품"
                    value={props.selectedProduct}
                    options={props.categoryList
                        .filter(category => productList.includes(category.type))
                        .map(category => category.type)}
                    onChange={handleProductChange}
                />
                {props.selectedProduct && filteredVersions.length > 0 && (
                    <SelectBox
                        label="버전"
                        value={props.selectedVersion}
                        options={filteredVersions}
                        onChange={(e) => props.setSelectedVersion(e.target.value)}
                    />
                )}
            </div>
        );
    };

    const SelectBox = ({ label, value, options, onChange }) => (
        <p className="docbox-cnts">
            <select value={value} onChange={onChange}>
                {options.map((option, index) => (
                    <option key={index} value={option}>
                        {`${label === "제품" ? "K-System" : ""} ${option.charAt(0).toUpperCase() + option.slice(1)}`}
                    </option>
                ))}
            </select>
        </p>
    );

    return (
        <div className="doc-nav">
            {makePathContent()}
            {versionContent()}
        </div>
    );
}
export default Location;